import { onboardingQuestionMap } from 'modules/config';

const onboardingFormData = {
  version: 3,
  name: 'Onboarding Form',
  groups: [
    // 1 -  BASICS
    {
      name: 'basics',
      header: 'Help us learn more about who you are today!',
      caption: 'Personal Info',
      intro:
        "<p>Hey there, and welcome to Nerd Fitness Coaching! As we embark on this journey together, we want to learn all we can about you so we can meet you where you are to build a program tailored to your needs.</p><This questionnaire will take approximately 20-30 minutes to complete, and you must fill everything out at once. We’ll use the info you provide, along with notes from your call, to match you up with a Coach perfectly suited to be your guide on your quest to level up. The information you share will never be shared publicly without your consent, so please answer each question candidly. We have a zero judgment policy and don’t care where you came from - only where you’re going.</p><p>This questionnaire will take approximately 20-30 minutes to complete, and we recommend filling everything out at once. We’ll use the info you provide, along with notes from your call, to match you up with a Coach perfectly suited to be your guide on your quest to level up. The information you share will never be shared publicly without your consent, so please answer each question candidly. We have a zero judgment policy and don’t care where you came from - only where you’re going.</p><p>Let's get started...</p>",
      fields: [
        {
          type: 'text',
          name: 'nickname',
          required: true,
          caption: 'What name do you prefer we call you?',
          customClassName: 'col-sm-12 col-md-6 mx-auto',
          placeholder: '',
        },
        {
          type: 'select',
          name: 'pronouns',
          required: true,
          caption: 'What pronouns do you use?',
          customClassName: 'col-sm-10 col-md-8',
          options: onboardingQuestionMap.pronouns,
        },
        {
          type: 'select',
          name: 'coachGenderPreference',
          required: false,
          caption: 'Do you prefer working with a Coach of a particular gender?',
          customClassName: 'col-sm-10 col-md-8',
          options: onboardingQuestionMap.coachGenders,
        },
        {
          type: 'date',
          name: 'birthday',
          caption: 'When is your birthday?',
          required: true,
          customClassName: 'col-12 mx-auto text-center',
          placeholder: '',
        },
        {
          type: 'fieldsArray',
          name: 'heightGroup',
          required: false,
          caption: 'How tall are you?',
          items: [
            {
              type: 'number',
              name: 'heightFeet',
              caption: '',
              placeholder: '',
              unit: 'ft',
            },
            {
              type: 'number',
              name: 'heightInches',
              caption: '',
              placeholder: '',
              unit: 'in',
            },
          ],
        },
        {
          type: 'text',
          name: 'weight',
          required: false,
          caption: 'What is your approximate weight?',
          customClassName: 'col-sm-12 col-md-6 mx-auto',
          placeholder: '',
        },

        {
          type: 'text',
          name: 'mailingAddress1',
          required: true,
          caption: 'Mailing Address 1',
          customClassName: 'col-sm-12 col-md-6 mx-auto',
          placeholder: '',
        },
        {
          type: 'text',
          name: 'mailingAddress2',
          caption: 'Mailing Address 2',
          customClassName: 'col-sm-12 col-md-6 mx-auto',
          placeholder: '',
        },
        {
          type: 'fieldsArray',
          required: false,
          name: 'addressGroup',
          caption: '',
          items: [
            {
              type: 'text',
              name: 'city',
              caption: 'City',
              required: true,
              customClassName: 'col-sm-10 col-md-10 mx-auto',
              placeholder: '',
            },
            {
              type: 'text',
              name: 'state',
              caption: 'State',
              required: true,
              customClassName: 'col-sm-10 col-md-10 mx-auto',
              placeholder: '',
            },
          ],
        },
        {
          type: 'fieldsArray',
          required: false,
          name: 'addressGroup2',
          caption: '',
          items: [
            {
              type: 'text',
              name: 'zip',
              required: true,
              caption: 'Zip',
              customClassName: 'col-sm-10 col-md-10 mx-auto',
              placeholder: '',
            },
            {
              type: 'text',
              name: 'country',
              caption: 'Country',
              required: true,
              customClassName: 'col-sm-10 col-md-10 mx-auto',
              placeholder: '',
            },
          ],
        },
        {
          type: 'phone',
          name: 'phoneNumber',
          required: true,
          caption: 'Phone Number',
          customClassName: 'col-sm-4 col-md-4 mx-auto text-center',
          placeholder: '',
        },
        {
          type: 'select',
          name: 'unitPreferences',
          required: true,
          caption: 'Which units of measurement would you prefer?',
          customClassName: 'col-sm-10 col-md-8',
          options: onboardingQuestionMap.unitPreferences,
        },
      ],
    },
    // 2 should be HABITS now, but renamed
    {
      name: 'Getting-to-know-you',
      header: 'Getting to Know You',
      caption: 'Getting To Know You',
      intro:
        '<p>We’ll focus a lot of our time together talking about fitness, nutrition, and lifestyle habit changes, but we want to build a relationship that goes a bit deeper than that. Before we get into the nitty gritty fitness details, let’s talk about the awesome human you are.</p>',
      fields: [
        {
          type: 'textarea',
          name: 'focusesPassions',
          caption:
            'Fitness and nutrition aside, what are 3 of the most important focuses or passions in your life right now?',
          required: true,
          subCaption:
            'Hobbies? Work projects? Interests? What makes you tick? ',
        },
        {
          type: 'textarea',
          name: 'importantPeoplePets',
          caption:
            'Who are the most important people (or pets!) in your world?',
          required: true,
        },
        {
          type: 'textarea',
          name: 'nerdyHobbies',
          caption:
            'What other hobbies, interests, or fandoms do you enjoy, if any?',
          required: false,
        },
        {
          type: 'textarea',
          name: 'interestingFact',
          caption:
            'What is one interesting fact about you that not many people know?',
        },
        {
          type: 'textarea',
          name: 'characterLike',
          caption:
            'Is there a character from a movie, tv, or book that you strive to be more like?',
        },
      ],
    },
    // 3 will be 'thinking about change'
    {
      name: 'thinking-about-change',
      caption: 'Thinking About Change',
      header: 'Thinking About Change',
      intro:
        '<p>You took your first courageous step in this journey by deciding to join. High five! In the questions that follow, tell us a little more about your motivations for taking that step and your expectations of our time together.</p>',
      fields: [
        {
          type: 'textarea',
          name: 'attractedNFCoaching',
          caption: 'What attracted you to Nerd Fitness Coaching?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
          placeholder: '',
        },
        {
          type: 'textarea',
          name: 'nervousAboutJourney',
          caption:
            'What are you most <i>nervous</i> about on this journey, if anything?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
          placeholder: '',
        },
        {
          type: 'textarea',
          name: 'excitedAbout',
          caption: 'On the flipside, what are you most <i>excited</i> about?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
          placeholder: '',
        },
        {
          type: 'textarea',
          name: 'retentionNotes',
          caption:
            'Why are you ready to make healthy lifestyle changes <i>now</i>?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'desiredCoachNumber',
          caption:
            'What is the <b>number one</b> thing you want to work on with your Coach?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
          // subCaption: '(Feel free to include additional goals here.)',
        },
        {
          type: 'textarea',
          name: 'coachExpectations',
          caption:
            'What expectations, if any, do you have of your Coach during our journey together?',
          required: true,
        },
        {
          type: 'select',
          name: 'bigProjectMostHelpful',
          caption:
            'Think about a time when you completed a big project at school/work.  Which of these was MOST helpful in accomplishing the task?',
          subCaption: '(Choose the best fit, even if it isn’t perfect.)',
          required: true,
          customClassName: 'col-sm-10 col-md-8',
          align: 'center',
          view: 'block',
          options: [
            {
              caption: '...',
              value: null,
            },
            {
              caption:
                'Having a clear direction for what this looked like when done and done well.',
              value:
                'Having a clear direction for what this looked like when done and done well.',
            },
            {
              caption:
                'Having a clear explanation of the justifications and reasoning behind the project.',
              value:
                'Having a clear explanation of the justifications and reasoning behind the project.',
            },
            {
              caption:
                'Having clear deadlines to meet, as well as other people relying on me.',
              value:
                'Having clear deadlines to meet, as well as other people relying on me.',
            },
            {
              caption:
                'Having the freedom to choose how I wanted to tackle the project, without any oversight.',
              value:
                'Having the freedom to choose how I wanted to tackle the project, without any oversight.',
            },
          ],
        },
        {
          type: 'select',
          name: 'whichDescribesYouBest',
          caption: 'Which of these do you think describes you the best?',
          subCaption: '(Choose the best fit, even if it isn’t perfect.)',
          required: true,
          customClassName: 'col-sm-10 col-md-8',
          align: 'center',
          view: 'block',
          options: [
            {
              caption: '...',
              value: null,
            },
            {
              caption:
                'I’m good at organizing my time to get both work and my personal goals accomplished.',
              value:
                'I’m good at organizing my time to get both work and my personal goals accomplished.',
            },
            {
              caption:
                'If I set my mind to doing something, I’ll often do it, even if it means ignoring peer pressure.',
              value:
                'If I set my mind to doing something, I’ll often do it, even if it means ignoring peer pressure.',
            },
            {
              caption:
                'I tend to work really hard when others need something from me, even if it means sacrificing my own time for someone else.',
              value:
                'I tend to work really hard when others need something from me, even if it means sacrificing my own time for someone else.',
            },
            {
              caption:
                'I put a high value on choice in all aspects of my life.  I tend to do things because I want to, not because I “should”.',
              value:
                'I put a high value on choice in all aspects of my life.  I tend to do things because I want to, not because I “should”.',
            },
          ],
        },
        {
          type: 'textarea',
          name: 'succeededInChangingHabit',
          caption:
            'Briefly tell us about a time when you succeeded in changing an important habit, even if for a short time.',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'obstacles',
          caption:
            'What obstacles, if any, have blocked your attempts to change in the past, or do you anticipate blocking your attempt this time?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'coachSupportTough',
          caption:
            'How can your Coach help support you best when times get tough or you encounter those obstacles?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'startingCoupleWeeksComingUp',
          caption:
            'What’s coming up for you in the next couple of weeks as we get started on the program?  What challenges, if any, could you see popping up?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'select',
          name: 'adjustmentConfidence',
          required: false,
          caption:
            'On a scale from 1-5, how confident are you that you’ll be able to make adjustments that align with your long term goals? ',
          subCaption: '(1 = not very confident, 5 = nothing can stop me!)',
          customClassName: 'col-sm-12 col-md-4',
          options: onboardingQuestionMap.oneToFiveScale,
        },
      ],
    },
    {
      name: 'fitness',
      caption: 'Fitness',
      header: 'Fitness',
      intro:
        '<p>Every person comes to Nerd Fitness Coaching with unique goals and priorities. The next three pages of questions will hone in on each of the pillars of a healthy lifestyle that we embrace at Nerd Fitness: Fitness, Nutrition, and Lifestyle/Mindset.</p>',
      fields: [
        {
          type: 'textarea',
          name: 'fitnessExperience',
          caption:
            'What experience do you have with fitness or physical activity? Any programs you have followed?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'pastWorkOuts',
          caption:
            'What are the biggest struggles you have had with exercising in the past?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'fitnessSuccessFirstMonth',
          caption:
            'In regards to fitness, what does success look like in our first month together?',
          required: true,
        },
        {
          type: 'textarea',
          name: 'goals',
          caption:
            'Thinking 6-12 months down the line, what fitness goals will future you be excited to have accomplished?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'text',
          name: 'daysWorkOut',
          caption: 'How many days a week do you <i>currently</i> exercise?',
          required: true,
          customClassName: 'col-sm-12 col-md-4 mx-auto',
        },
        {
          type: 'text',
          name: 'daysCommitWorkout',
          caption:
            'How many days per week, if any, would you like to exercise as we get started?',
          required: true,
          customClassName: 'col-sm-12 col-md-4 mx-auto',
        },
        {
          type: 'textarea',
          name: 'daysBestWorkOuts',
          caption:
            'Which days are typically best for your workouts? Any days that are completely unavailable?',
          required: true,
          customClassName: 'col-sm-10 mx-auto',
        },
        {
          type: 'text',
          name: 'timePerWorkout',
          caption:
            'How much time per workout are you ready to commit as we build your initial plan?',
          required: true,
          customClassName: 'col-sm-12 col-md-4 mx-auto',
        },
        {
          type: 'textarea',
          name: 'workoutLocation',
          caption:
            'Do you prefer to complete most of your workouts at home, at the gym, on-the-go, a little of each, or someplace else?',
          required: true,
          customClassName: 'col-sm-10 mx-auto',
        },
        // {
        //   type: 'text',
        //   name: 'currentTrainingProgram',
        //   caption:
        //     'Are you currently following a specific training program that you enjoy? If so, provide details.',
        //   customClassName: 'col-sm-10 col-md-6 mx-auto',
        //   placeholder: '',
        // },
        // {
        //   type: 'select',
        //   name: 'completingWorkOuts',
        //   caption: 'Where do you prefer to complete most of your workouts?',
        //   customClassName: 'col-sm-10 col-md-8',
        //   options: [
        //     {
        //       caption: '...',
        //       value: 'null',
        //     },
        //     {
        //       caption: 'At a gym',
        //       value: 'gym',
        //     },
        //     {
        //       caption: 'At home',
        //       value: 'home',
        //     },
        //     {
        //       caption: 'A combination of both',
        //       value: 'both',
        //     },
        //   ],
        // },

        // {
        //   type: 'multiselect',
        //   name: 'availableWorkOuts',
        //   caption: 'What equipment do you have available for your workouts?',
        //   subCaption: '(check all that apply)',
        //   view: 'double',
        //   labels: [
        //     'Jump rope',
        //     'Resistance Bands',
        //     'TRX',
        //     'Dumbbells',
        //     'Pull-up Bar',
        //     'Gymnastic rings',
        //     'Squat rack',
        //     'Barbell',
        //   ],
        // },

        {
          type: 'textarea',
          name: 'additionalEquipment',
          required: true,
          caption:
            'What equipment do you have available for your workouts? If you prefer to workout at the gym, briefly describe the type of gym you go to.',
          customClassName: 'col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'extraEquipmentLearnOrDislike',
          required: true,
          caption:
            'Are there any pieces of equipment you enjoy using or want to learn how to use? Any pieces you dislike?',
          customClassName: 'col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'exerciseActivitiesRegular',
          required: true,
          caption:
            'Are there any types of exercises or activities that you’re interested in making a regular part of your life? Any you dislike?',
          customClassName: 'col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'injuries',
          required: true,
          caption:
            'Any past or present injuries or daily discomforts that would affect physical activity? What rehabilitation, if any, have you undergone?',
          customClassName: 'col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'concerns',
          required: true,
          caption:
            'What, if any, physical concerns or apprehensions do you have with starting this program?',
          customClassName: 'col-md-10 mx-auto',
        },
        {
          type: 'select',
          name: 'scaleChangeFitnessHabits',
          caption:
            'On a scale of 1-5, how ready are you to make changes to your fitness habits? ',
          subCaption: '(1 = not very confident, 5 = nothing can stop me!)',
          required: true,
          customClassName: 'col-sm-12 col-md-4',
          options: onboardingQuestionMap.oneToFiveScale,
        },
      ],
    },
    {
      name: 'nutrition-info',
      caption: 'Nutrition',
      header: 'Nutrition',
      intro:
        '<p>They say nutrition is 80-90% of the battle as we work to hit fitness goals, and every client comes to NF Coaching with varied experience. From kitchen novices to expert chefs, counting macros to snapping photos of each meal to create awareness, there are no wrong starting points. Tell us a little more about your nutrition path!</p>',
      fields: [
        {
          type: 'textarea',
          name: 'biggestPastNutrition',
          required: true,
          caption:
            "What's the biggest struggle you've had with nutrition in the past?",
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'foundSuccess',
          caption:
            'What, if anything, has worked for you regarding nutrition in the past?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
          // subCaption: '(What kind of routines, nutrition, etc.)',
        },
        {
          type: 'textarea',
          name: 'averageDayEating',
          caption: 'What does an average day of eating look like for you now?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
          // subCaption: '(What kind of routines, nutrition, etc.)',
        },
        {
          type: 'textarea',
          name: 'nutritionSuccessFirstMonth',
          caption:
            'In regards to nutrition, what does success look like in our first month together?',
          subCaption:
            'Do you want to learn a skill? Begin modifying a particular habit? Become more aware of what you’re eating? Hone in on a macro breakdown that suits your goals? Something else?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'nutritionFutureGoals',
          caption:
            'Thinking 6-12 months down the line, what nutrition goals will future you be excited to have accomplished?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'nutritionChanges',
          caption:
            'What, if any, nutrition changes are you interested in tackling or learning more about first?',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'select',
          name: 'scaleEnjoyCooking',
          caption: 'On a scale of 1-5, how much do you enjoy cooking?',
          subCaption: '(1 = I never want to cook, 5 = I love cooking!)',
          required: true,
          customClassName: 'col-sm-12 col-md-4',
          options: onboardingQuestionMap.oneToFiveScale,
        },
        // {
        //   type: 'multiselect',
        //   name: 'nutritionalExperience',
        //   caption: "What's your experience with nutrition?",
        //   subCaption: '(Check all that apply)',
        //   required: true,
        //   align: 'center',
        //   view: '',
        //   labels: [
        //     'I am a complete food newbie - I eat whatever I want, whenever I want',
        //     "I'm aware that I eat some foods that are unhealthy, but I'm not sure how to change these habits.",
        //     'I know how to read a nutritional label and generally know what macronutrients are.',
        //     "I've counted calories before and it caused me anxiety, or it is something I'm not comfortable with doing.",
        //     'I weigh and measure everything I eat (or have in the past) and am completely comfortable with this',
        //     "I've tried diets like Paleo, Whole 30, Atkins, Keto, or IIFYM",
        //   ],
        // },
        {
          type: 'select',
          name: 'comfortableInTheKitchen',
          subCaption:
            '(1 = I have no idea what I’m doing, 5 = I’m a pretty proficient cook!)',
          caption:
            'On a scale of 1-5, what’s your comfort level in the kitchen? ',
          required: true,
          customClassName: 'col-sm-12 col-md-6',
          options: onboardingQuestionMap.oneToFiveScale,
        },
        {
          type: 'textarea',
          name: 'preparesMeals',
          caption: 'Who prepares most of your meals currently? ',
          subCaption: '(Ex: Me, a family member or roommate, fast food, etc)',
          required: true,
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'specificDietaryRestriction',
          caption:
            'Do you have any specific dietary restriction or preferences?',
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'eatingStress',
          caption:
            'Are there any times you feel more stressed about eating than normal?',
          subCaption:
            '(Ex: social situations, at work, sitting in front of the tv, etc)',
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'troubleAvoidingFoods',
          caption: 'Are there any types of foods you have trouble avoiding?',
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'textarea',
          name: 'foodEatMoreDislike',
          caption:
            'Are there any types of foods you want to eat more of but generally dislike?',
          customClassName: 'col-sm-12 col-md-10 mx-auto',
        },
        {
          type: 'select',
          name: 'scaleReadyNutritionHabits',
          caption:
            'On a scale of 1-5, how ready are you to make changes to your nutrition habits?',
          subCaption: '(1 = not very confident, 5 = nothing can stop me!)',
          required: true,
          customClassName: 'col-sm-12 col-md-6',
          options: onboardingQuestionMap.oneToFiveScale,
        },
        // {
        //   type: 'multiselect',
        //   name: 'mostEatMeals',
        //   caption: 'Where do you eat most of your meals?',
        //   align: 'center',
        //   view: 'double',
        //   labels: [
        //     'At home or work, with food we prepare',
        //     'At home or work, with takeout',
        //     'At a restaurant or drive-thru',
        //     'From a cafeteria',
        //   ],
        // },
      ],
    },
    {
      name: 'lifestyle-mindset',
      caption: 'Lifestyle/Mindset',
      header: 'Lifestyle/Mindset',
      intro:
        '<p>Last (but not least), let’s talk about your lifestyle and mindset. While fitness and nutrition typically make up a significant part of your programming, there are plenty of other important factors that will impact your ability to hit the goals we set together.</p> <p>With your lifestyle, there may be stress, poor sleep, or less than ideal social support. With your mindset, there may be any number of tough thoughts that you deal with as we work towards change. Your Coach can also help work with you on sustainable habit changes to help in these areas too!</p>',

      fields: [
        {
          type: 'textarea',
          name: 'lifestyleMindsetHabits',
          caption:
            'What, if any, additional lifestyle or mindset habits would you be interested in working on with your Coach?',
          subCaption:
            '(Ex: stress, sleep, meditation, social support, hobbies, decluttering, etc)',
        },
        {
          type: 'text',
          name: 'cigarettesPerWeek',
          caption: 'Do you smoke? If so, approximately how many per day?',
          customClassName: 'col-sm-10 col-md-4',
        },
        {
          type: 'text',
          name: 'drinksPerWeek',
          caption: 'Do you drink alcohol? How many drinks per week?',
          required: true,
          customClassName: 'col-sm-10 col-md-4',
        },
        {
          type: 'text',
          name: 'hoursSleepNight',
          caption: 'On average, how many hours of sleep do you get a night?',
          required: true,
          customClassName: 'col-sm-10 col-md-4',
        },
        {
          type: 'select',
          name: 'scaleSleepQuality',
          multiple: false,
          caption: 'On a scale of 1-5, how would you rate your sleep quality? ',
          subCaption:
            '(1 = I’m always dragging, 5 = I feel fantastic every morning)',
          required: true,
          customClassName: 'col-sm-12 col-md-6',
          options: onboardingQuestionMap.oneToFiveScale,
        },
        {
          type: 'textarea',
          name: 'travel',
          caption:
            'How often do you travel? For how long at a time? Are there any unique challenges that come with your travel schedule?',
          required: true,
        },
        {
          type: 'textarea',
          name: 'yourHousehold',
          caption:
            'What are your living arrangements? How do they have a positive or negative impact, if any, on your goals?',
          required: true,
        },
        {
          type: 'textarea',
          name: 'howMuchSupport',
          caption:
            'How much support do you have from family, friends and coworkers on your quest to get healthy?',
          required: true,
        },
        {
          type: 'textarea',
          name: 'existingPractitionerSupport',
          caption:
            'Are you working with any other practitioners on your health and wellness goals (doctor, therapist, nutritionist, physical therapist, etc.)?',
          required: true,
        },
        {
          type: 'select',
          name: 'currentStressLevel',
          caption:
            'On a scale from 1-5, what is your current average level of stress?',
          subCaption: '(1 = super calm, 5 = every day is mentally exhausting)',
          required: true,
          customClassName: 'col-sm-12 col-md-6',
          options: onboardingQuestionMap.oneToFiveScale,
        },
        {
          type: 'textarea',
          name: 'stressCatalyst',
          caption:
            'In times of higher stress, what is typically the catalyst? What do you typically do to cope?',
          required: true,
        },
        {
          type: 'textarea',
          name: 'averageWeekdayTime',
          caption: 'On an average weekday, how do you spend your time?',
          required: true,
        },
        {
          type: 'textarea',
          name: 'averageWeekendTime',
          caption: 'On an average weekend, how do you spend your time?',
          required: true,
        },
        {
          type: 'select',
          name: 'scaleMindsetChanges',
          caption:
            'On a scale of 1-5, how ready are you to make changes to your mindset habits?',
          subCaption: '(1 = not very confident, 5 = nothing can stop me!)',
          required: true,
          customClassName: 'col-sm-12 col-md-6',
          options: onboardingQuestionMap.oneToFiveScale,
        },

        // {
        //   type: 'textarea',
        //   name: 'kryptonite',
        //   caption: 'What is your kryptonite in your quest to get healthy?',
        //   required: true,
        //   subCaption:
        //     'This could be anything that constantly impedes you from achieving your goals: self-sabotaging mindset, unsupportive family, insatiable sweet tooth, inconsistent motivation, etc.',
        // },
      ],
    },
    {
      name: 'finish',
      caption: 'And Away We Go!',
      header: 'And Away We Go!',
      intro:
        '<p>Whew! We covered a lot of ground!! Thanks for taking the time to tell us what’s important in your own words.</p>',

      fields: [
        {
          type: 'select',
          name: 'prioritiesFirst',
          caption:
            'Reflecting on everything we’ve just gone over regarding fitness, nutrition, and lifestyle/mindset, which category is your MOST important area of focus as we begin building your customized program together?',
          customClassName: 'col-sm-10 col-md-8',
          options: [
            {
              caption: '...',
              value: 'null',
            },
            {
              caption: 'Fitness',
              value: 'fitness',
            },
            {
              caption: 'Nutrition',
              value: 'nutrition',
            },
            {
              caption: 'Mindset',
              value: 'mindset',
            },
          ],
        },
        {
          type: 'select',
          name: 'prioritiesSecond',
          caption: 'Which category is your next priority?',
          customClassName: 'col-sm-10 col-md-8 mx-auto',
          options: [
            {
              caption: '...',
              value: 'null',
            },
            {
              caption: 'Fitness',
              value: 'fitness',
            },
            {
              caption: 'Nutrition',
              value: 'nutrition',
            },
            {
              caption: 'Mindset',
              value: 'mindset',
            },
          ],
        },
        {
          type: 'textarea',
          name: 'wantToKnowAboutCoach',
          customClassName: 'col-sm-10 col-md-8 mx-auto',
          caption:
            'Is there anything we didn’t cover that you’d like your Coach to know?',
        },
      ],
    },
  ],
};

export default onboardingFormData;
